export var SpacerDirection;

(function (SpacerDirection) {
  SpacerDirection["VERTICAL"] = "vertical";
  SpacerDirection["HORIZONTAL"] = "horizontal";
})(SpacerDirection || (SpacerDirection = {}));

export var SpaceVariant;

(function (SpaceVariant) {
  SpaceVariant["XXXS"] = "xxxs";
  SpaceVariant["XXS"] = "xxs";
  SpaceVariant["XS"] = "xs";
  SpaceVariant["S"] = "s";
  SpaceVariant["M"] = "m";
  SpaceVariant["L"] = "l";
  SpaceVariant["XL"] = "xl";
  SpaceVariant["XXL"] = "xxl";
  SpaceVariant["XXXL"] = "xxxl";
})(SpaceVariant || (SpaceVariant = {}));